<script setup>
import { ref, onMounted, watch } from 'vue'

const props = defineProps({
    workflowId: Number,
    nodes: Array,
    isPublished: Boolean,
})

const stats = ref([])

async function fetchStats() {
    if (!props.isPublished) return
    try {
        const response = await fetch(`/bo/communications/api/v1/workflows/${props.workflowId}/stats`)
        const result = await response.json()
        stats.value = result.data || []
    } catch (e) {
        console.error('Failed to fetch stats', e)
    }
}

function getNodeStats(nodeId) {
    return stats.value.find(s => s.node_uid === nodeId)
}

onMounted(fetchStats)
watch(() => props.isPublished, (val) => { if (val) fetchStats() })
</script>

<template>
    <div v-if="isPublished && stats.length" class="funnel-overlay">
        <div
            v-for="node in nodes"
            :key="node.id"
            v-show="getNodeStats(node.id)"
            class="funnel-badge"
            :style="{ left: (node.position.x + 170) + 'px', top: node.position.y + 'px' }"
        >
            <span class="funnel-badge__count">{{ getNodeStats(node.id)?.total_entered || 0 }}</span>
            <span class="funnel-badge__rate" v-if="getNodeStats(node.id)?.conversion_rate > 0">
                {{ Math.round(getNodeStats(node.id).conversion_rate * 100) }}%
            </span>
        </div>
    </div>
</template>

<style scoped>
.funnel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 10;
}
.funnel-badge {
    position: absolute;
    background: rgba(0, 0, 0, 0.75);
    color: white;
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 4px;
    white-space: nowrap;
    display: flex;
    gap: 4px;
    align-items: center;
}
.funnel-badge__count {
    font-weight: 700;
}
.funnel-badge__rate {
    color: #34d399;
}
</style>
